import { apiPost, apiThrow } from './api';

/**
 * THE "invite this person into this department" call and its result wording,
 * used by `AddPersonForm` — which the one "+ Add person" box (AddPersonPanel,
 * 2026-11-03) opens on both the department card and Settings → Users. One
 * request shape, one set of messages.
 *
 * `POST /api/invitations` (manager-only, R24) adopts-or-OFFERS: a new address
 * is added and emailed a set-password link; an address that already has an
 * account gets a "Join this department?" offer they accept from their switcher.
 *
 * Throws (via apiThrow) on a refusal; resolves `{ message, tone, seated }`,
 * `seated` true when the person is in the department now (a brand-new person),
 * false when an offer is waiting on them.
 */
// `requestOptions` carries the caller's `{ headers: { 'Idempotency-Key': … } }`,
// written AT THE CALL SITE so `idempotencyKeySites.manifest.test.js` can see it.
export async function sendDepartmentInvite({ email, name, role, dept, requestOptions }) {
  const res = await apiPost('/api/invitations', {
    email,
    name,
    role,
    production_id: dept.production_id,
    department_id: dept.id,
  }, requestOptions);
  if (!res.ok) await apiThrow(res);
  const data = await res.json();
  if (data.department_invite_id != null && !data.awaiting_reactivation) {
    return {
      message: `${email} already uses CrewForge, so they have been asked to join ${dept.name || 'this department'}. `
        + 'They will see it in their department switcher.',
      tone: 'success',
      seated: false,
    };
  }
  if (data.awaiting_reactivation) {
    return { message: data.message || `Invitation saved for ${email}.`, tone: 'warning', seated: false };
  }
  if (data.email_sent === false) {
    return {
      message: `${name} added, but the invitation email could not be sent. `
        + 'Ask them to sign in with "Forgot password" instead.',
      tone: 'warning',
      seated: true,
    };
  }
  return { message: data.message || `Invitation sent to ${email}.`, tone: 'success', seated: true };
}
